import React from "react";
import { Wrapper, AlignButton, Gap } from "./style";

// Simple SVG icons representing text alignment 
const LeftIcon = () => (
    <svg width="30" height="30" fill="currentColor" viewBox="0 0 24 24">
        <rect x="3" y="5" width="14" height="2" />
        <rect x="3" y="9" width="20" height="2" />
        <rect x="3" y="13" width="14" height="2" />
        <rect x="3" y="17" width="20" height="2" />
    </svg>
);

const CenterIcon = () => (
    <svg width="30" height="30" fill="currentColor" viewBox="0 0 24 24">
        <rect x="5" y="5" width="14" height="2" />
        <rect x="3" y="9" width="18" height="2" />
        <rect x="5" y="13" width="14" height="2" />
        <rect x="3" y="17" width="18" height="2" />
    </svg>
);

const RightIcon = () => (
    <svg width="30" height="30" fill="currentColor" viewBox="0 0 24 24">
        <rect x="7" y="5" width="16" height="2" />
        <rect x="3" y="9" width="20" height="2" />
        <rect x="7" y="13" width="16" height="2" />
        <rect x="3" y="17" width="20" height="2" />
    </svg>
);

const VerticalAlignTopIcon = () => (
    <svg width="30" height="24" viewBox="0 0 24 24" fill="currentColor" >
        <line x1="-10" y1="3" x2="25" y2="3" stroke="currentColor" strokeWidth="2"/>
        <rect x="5" y="3" width="12" height="20" stroke="currentColor" strokeWidth="2" fill="none"/>
    </svg>
);

const VerticalAlignCenterpIcon = () => (
    <svg width="30" height="24" viewBox="0 0 24 24" fill="currentColor" >
        <line x1="-10" y1="14" x2="4" y2="14" stroke="currentColor" strokeWidth="2"/>
        <rect x="4" y="4" width="12" height="19" stroke="currentColor" strokeWidth="2" fill="none"/>
        <line x1="25" y1="14" x2="18" y2="14" stroke="currentColor" strokeWidth="2"/>
    </svg>
);


const VerticalAlignBottomIcon = () => (
    <svg width="30" height="24" viewBox="0 0 24 24" fill="currentColor" >
        <line x1="-100" y1="23" x2="25" y2="23" stroke="currentColor" strokeWidth="2"/>
        <rect x="5" y="3" width="12" height="20" stroke="currentColor" strokeWidth="2" fill="none"/>
    </svg>
);


const TextAlignSelector = ({ value = "left", onChange }) => {

    const handleClick = (align) => {
        let textAlign = value.textAlign;
        let verticalAlign = value.verticalAlign;

        if (["left", "center", "right"].includes(align)) {
            textAlign = align;
        } else if (["top", "bottom", "center center"].includes(align)) {
            verticalAlign = align === "center center" ? "center" : align;
        }

        if (onChange) onChange({ textAlign, verticalAlign });
    };

    const alignOptions = [
        { type: "left", icon: <LeftIcon /> },
        { type: "center", icon: <CenterIcon /> },
        { type: "right", icon: <RightIcon /> },
        { type: "top", icon: <VerticalAlignTopIcon /> },
        { type: "center center", icon: <VerticalAlignCenterpIcon /> },
        { type: "bottom", icon: <VerticalAlignBottomIcon /> },
    ];

    return (
        <Wrapper>
            {alignOptions.slice(0, 3).map(({ type, icon }) => (
                <AlignButton
                    key={type}
                    active={value.textAlign === type}
                    onClick={() => handleClick(type)}
                    title={type}
                    aria-label={`Align ${type}`}
                >
                    {icon}
                </AlignButton>
            ))}
            <Gap/>
            {alignOptions.slice(3, 6).map(({ type, icon }) => (
                <AlignButton
                    key={type}
                    active={value.verticalAlign === type || (type === "center center" && value.verticalAlign === "center")}
                    onClick={() => handleClick(type)}
                    title={type}
                    aria-label={`Align ${type}`}
                >
                    {icon}
                </AlignButton>
            ))}
        </Wrapper>
    );
};

export default TextAlignSelector;
